module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":{"user":"Sign up","shop":"Store entry"}},"ja":{"title":{"user":"ユーザーの 新規作成","shop":"店舗の 新規登録"}}}')
  delete Component.options._Ctor
}
